const ELEMENTS = [
	'p',
	'div',
	'h1',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'ol',
	'ul',
	'li',
	'figure',
	'nav',
	'pre',
	'header',
	'section',
	'aside',
	'footer',
	'main',
];

export default ELEMENTS;
